import React from "react";
import { Handshake, Leaf, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  title: "Faire Festpreise",
  description: "\n",
  icon: ShieldCheck,
  titleClassName: "text-card-foreground flex flex-col gap-6 py-6 group relative border border-border bg-card shadow-lg transition-all duration-300 hover:-translate-y-[8px] hover:shadow-2xl rounded-md !bg-[url(https://joint-slug.10web.cloud/wp-content/uploads/2026/03/bathroom_before_2.webp)]"
}];
export default function DasBlauMeisterVersprechen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}